.antCheckbox.antCheckbox {
  :global(.ant-checkbox-disabled) + span {
    color: var(--x-color-text-primary);
  }

  :global(.ant-checkbox) :global(.ant-checkbox-inner) {
    border: 1px solid var(--x-color-border);
  }

  :global(.ant-checkbox) :global(.ant-checkbox-input):focus + :global(.ant-checkbox-inner) {
    border-color: var(--x-color-border);
  }

  :global(.ant-checkbox) :global(.ant-checkbox-input):checked + :global(.ant-checkbox-inner) {
    border-color: transparent;
  }
}
